var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["featureEnabled"]: () => __WEBPACK_EXTERNAL_MODULE__canopytax_feature_toggles_2242b675__.featureEnabled });